import { a as getExcelReportProjects, c as deleteProject, i as getProjectById, l as createProjectWithoutTemplate, n as getProjectUsers, o as getById, r as getProjectByIds, s as getAllProjects, t as updateProject, u as createProject } from "./updateProject2.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/project-gge/projectController/hooks/useCreateProject.ts
const createProjectMutationKey = () => [{ url: "/project" }];
function createProjectMutationOptions(config = {}) {
	const mutationKey = createProjectMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await createProject({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать проект.
* {@link /project}
*/
function useCreateProject(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? createProjectMutationKey();
	const baseOptions = createProjectMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useCreateProjectWithoutTemplate.ts
const createProjectWithoutTemplateMutationKey = () => [{ url: "/project/templatelessness" }];
function createProjectWithoutTemplateMutationOptions(config = {}) {
	const mutationKey = createProjectWithoutTemplateMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await createProjectWithoutTemplate({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать проект без шаблона
* {@link /project/templatelessness}
*/
function useCreateProjectWithoutTemplate(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? createProjectWithoutTemplateMutationKey();
	const baseOptions = createProjectWithoutTemplateMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useDeleteProject.ts
const deleteProjectMutationKey = () => [{ url: "/project/:projectId" }];
function deleteProjectMutationOptions(config = {}) {
	const mutationKey = deleteProjectMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await deleteProject({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить проект по его id.
* @deprecated
* {@link /project/:projectId}
*/
function useDeleteProject(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? deleteProjectMutationKey();
	const baseOptions = deleteProjectMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetAllProjects.ts
const getAllProjectsQueryKey = () => [{ url: "/project" }];
function getAllProjectsQueryOptions(config = {}) {
	const queryKey = getAllProjectsQueryKey();
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getAllProjects({
				...config,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список проектов.
* {@link /project}
*/
function useGetAllProjects(options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey = resolvedOptions?.queryKey ?? getAllProjectsQueryKey();
	const queryResult = useQuery({
		...getAllProjectsQueryOptions(config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetById.ts
const getByIdQueryKey = ({ path }) => [{
	url: "/project/:projectId/info",
	params: path
}];
function getByIdQueryOptions({ path }, config = {}) {
	const queryKey = getByIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getById({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть проект по его id. Игнорируется наличие у пользователя доступа к проекту.
* {@link /project/:projectId/info}
*/
function useGetById({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetExcelReportProjects.ts
const getExcelReportProjectsMutationKey = () => [{ url: "/project/report" }];
function getExcelReportProjectsMutationOptions(config = {}) {
	const mutationKey = getExcelReportProjectsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ query, body }) => {
			const { data } = await getExcelReportProjects({
				...config,
				query,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* {@link /project/report}
*/
function useGetExcelReportProjects(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? getExcelReportProjectsMutationKey();
	const baseOptions = getExcelReportProjectsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetProjectById.ts
const getProjectByIdQueryKey = ({ path }) => [{
	url: "/project/:id",
	params: path
}];
function getProjectByIdQueryOptions({ path }, config = {}) {
	const queryKey = getProjectByIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getProjectById({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть проект по его id.
* {@link /project/:id}
*/
function useGetProjectById({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getProjectByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getProjectByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetProjectByIds.ts
const getProjectByIdsQueryKey = ({ query }) => [{ url: "/project/info" }, ...query ? [query] : []];
function getProjectByIdsQueryOptions({ query }, config = {}) {
	const queryKey = getProjectByIdsQueryKey({ query });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getProjectByIds({
				...config,
				query,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Вернуть список проектов по их id.
* {@link /project/info}
*/
function useGetProjectByIds({ query }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { query: typeof query === "function" ? query() : query };
	const queryKey = resolvedOptions?.queryKey ?? getProjectByIdsQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getProjectByIdsQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useGetProjectUsers.ts
const getProjectUsersQueryKey = ({ path }) => [{
	url: "/project/:projectId/users",
	params: path
}];
function getProjectUsersQueryOptions({ path }, config = {}) {
	const queryKey = getProjectUsersQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getProjectUsers({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить список пользователей и их ролей в проекте.
* {@link /project/:projectId/users}
*/
function useGetProjectUsers({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getProjectUsersQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getProjectUsersQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/project-gge/projectController/hooks/useUpdateProject.ts
const updateProjectMutationKey = () => [{ url: "/project" }];
function updateProjectMutationOptions(config = {}) {
	const mutationKey = updateProjectMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await updateProject({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Обновить данные существующего проекта. Только данные проекта без назначенных пользователей и меты.
* {@link /project}
*/
function useUpdateProject(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? updateProjectMutationKey();
	const baseOptions = updateProjectMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { useCreateProject as A, deleteProjectMutationOptions as C, useCreateProjectWithoutTemplate as D, createProjectWithoutTemplateMutationOptions as E, createProjectMutationKey as O, deleteProjectMutationKey as S, createProjectWithoutTemplateMutationKey as T, getByIdQueryOptions as _, getProjectUsersQueryOptions as a, getAllProjectsQueryOptions as b, getProjectByIdsQueryOptions as c, getProjectByIdQueryOptions as d, useGetProjectById as f, getByIdQueryKey as g, useGetExcelReportProjects as h, getProjectUsersQueryKey as i, createProjectMutationOptions as k, useGetProjectByIds as l, getExcelReportProjectsMutationOptions as m, updateProjectMutationOptions as n, useGetProjectUsers as o, getExcelReportProjectsMutationKey as p, useUpdateProject as r, getProjectByIdsQueryKey as s, updateProjectMutationKey as t, getProjectByIdQueryKey as u, useGetById as v, useDeleteProject as w, useGetAllProjects as x, getAllProjectsQueryKey as y };

//# sourceMappingURL=useUpdateProject2.js.map